
import ABuilder from '../../tools/ABuilder';
import BaseComponent from '../BaseComponent';

class InputAmount extends BaseComponent{

    constructor(aElement){
        
        super(aElement);
                
        this.input      = this.element.find('.input-element');
        this.shadow     = this.element.find('.input-shadow'); // element that will help us with the currency symbol display
        this.value      = this.element.find('.input-value');  // hidden element that will hold the non formatted value
        
        this.min        = parseInt(this.element.data('min'))    || 1000;
        this.max        = parseInt(this.element.data('max'))    || 100000;
        this.currency   = this.element.data('currency')         || '€';
        
        if(this.element.data('value')){
            this.setValue(this.element.data('value'));
        }
        
        this.attachEvents();
        
    }
    
    attachEvents(){
        
        this.input.on('keydown',(event) => {

            let allowedKeys = [8, 9, 27, 13];

            // Allow: backspace, delete, tab, escape, enter and .
            if (allowedKeys.indexOf(event.keyCode) !== -1 ||
                // Allow: Ctrl+A, Command+A
                (event.keyCode == 65 && ( event.ctrlKey === true || event.metaKey === true ) ) ||
                // Allow: home, end, left, right, down, up
                (event.keyCode >= 35 && event.keyCode <= 40)
            ){
                // let it happen, don't do anything

                return;
            }

            let key = event.key;

            if(isNaN(key)){
                event.preventDefault();
                event.stopPropagation();
                return false;
            }

        });

        // update shadow elements
        
        this.input.on('keyup',(event) => {
            this.shadow.html(this.input.val()+' €');
        });

        this.input.on('change',(event) => {
            this.shadow.html(this.input.val()+' €');
        });

        this.input.on('focus',(event) => {
            this.input.val(this.removeFormattedAmount(this.input.val()));
            this.shadow.html(this.input.val()+' €');
            this.shadow.hide();
        });

        this.input.on('blur',(event) => {
            
            let amount = this.input.val();

            if(amount > this.max){
                amount = this.max;
            }else if(amount < this.min){
                amount = this.min;
            }
            
            // If, for some reason, the amount is not a number, default to min value
            if(isNaN(amount)){
                amount = this.min;
            }

            this.setValue(amount);

        });
        
    }
    
    setValue(aAmount){
        
        let formattedValue = this.formatAmount(aAmount);
        
        this.input.val(formattedValue);
        this.shadow.html([ABuilder('span',{'class':'amount'},formattedValue),' '+this.currency]);
        this.shadow.show();
        this.value.val(aAmount);
        
        this.onChange(this.value.attr('name'),aAmount);
                
    }

    formatAmount(aAmount,aSign=false){

        let amount = Number(aAmount) + '';

        if(aSign){
            amount = (amount>0?'+':'') + amount;
        }

        amount = amount.replace(/\./g,',');
        let parts = amount.toString().split(",");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        
        return parts.join(",");

    }

    removeFormattedAmount (aAmount){

        let amount = String(aAmount);
        
        amount = amount
            .replace('+','')
            .replace(/\./g,'')
            .replace(/\,/g,'.');
        
        return amount;

    }
    
}

export default InputAmount;